import styled from 'styled-components';

export const Wrap = styled.div`
  max-width: 820px;
  margin: 0 auto;
  padding: 24px 16px 60px;
`;

export const Titulo = styled.h1`
  text-align: center;
  color: var(--jk-text);
  font-size: 26px;
  font-weight: bold;
  margin: 12px 0 6px;
`;

export const Subtitulo = styled.p`
  text-align: center;
  color: var(--jk-text);
  opacity: 0.8;
  font-size: 15px;
  margin: 0 auto 18px;
  max-width: 620px;
`;

export const AvisoBox = styled.div`
  background: #fff7e6;
  border: 1px solid #ffe0a3;
  border-radius: 12px;
  padding: 12px 16px;
  color: #7a5a00;
  font-size: 13.5px;
  line-height: 1.5;
  margin: 0 auto 22px;
  max-width: 720px;
`;

export const CartaoCrianca = styled.div`
  background: var(--white-color, #fff);
  border: 1px solid rgba(0,0,0,0.06);
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 22px;
  box-shadow: var(--elev-1, 0 2px 8px rgba(0,0,0,0.08));
`;

export const NomeCrianca = styled.h2`
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--jk-text);
  font-size: 20px;
  font-weight: bold;
  margin: 0 0 14px;
  img { width: 40px; height: 40px; border-radius: 50%; object-fit: cover; }
`;

export const Bloco = styled.div`
  border-top: 1px dashed rgba(0,0,0,0.10);
  padding: 14px 0 4px;
  &:first-of-type { border-top: none; }
`;

export const TituloBloco = styled.h3`
  color: var(--jk-text);
  font-size: 16px;
  font-weight: bold;
  margin: 0 0 10px;
`;

export const LinhaSelos = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

export const Selo = styled.div`
  background: ${(p) => p.cor || '#eef2f7'};
  color: ${(p) => (p.escuro ? '#fff' : 'var(--jk-text)')};
  border-radius: 12px;
  padding: 10px 14px;
  font-size: 14px;
  font-weight: 600;
  b { font-size: 18px; display: block; }
`;

export const Texto = styled.p`
  color: var(--jk-text);
  font-size: 14px;
  line-height: 1.5;
  margin: 4px 0;
`;

export const Tranquilo = styled.div`
  background: #e9f8ee;
  border: 1px solid #b6e6c6;
  color: #1e7a44;
  border-radius: 12px;
  padding: 12px 14px;
  font-size: 14px;
`;

export const Atencao = styled.div`
  background: #fdecec;
  border: 1px solid #f5b9b9;
  color: #a12626;
  border-radius: 12px;
  padding: 12px 14px;
  font-size: 14px;
  margin-top: 8px;
  b { display: block; margin-bottom: 4px; }
`;

/* Portão dos Pais */
export const PortaoWrap = styled.div`
  max-width: 420px;
  margin: 60px auto;
  background: var(--white-color, #fff);
  border-radius: 16px;
  padding: 30px 24px;
  text-align: center;
  box-shadow: var(--elev-1, 0 2px 8px rgba(0,0,0,0.08));
`;

export const PortaoTitulo = styled.h2`
  color: var(--jk-text);
  font-size: 20px;
  margin: 0 0 6px;
`;

export const PortaoConta = styled.div`
  font-size: 30px;
  font-weight: bold;
  color: var(--jk-text);
  margin: 18px 0;
`;

export const PortaoInput = styled.input`
  width: 120px;
  font-size: 22px;
  text-align: center;
  padding: 10px;
  border: 2px solid #cdd6e0;
  border-radius: 10px;
  outline: none;
  &:focus { border-color: #4FA3E3; }
`;

export const PortaoBotao = styled.button`
  display: block;
  margin: 16px auto 0;
  background: #4FA3E3;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 12px 28px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
`;

export const PortaoErro = styled.p`
  color: #c0392b;
  font-size: 14px;
  margin: 10px 0 0;
  min-height: 18px;
`;

export const Voltar = styled.button`
  background: none;
  border: none;
  color: #4FA3E3;
  font-size: 15px;
  cursor: pointer;
  padding: 6px 0;
  margin-bottom: 8px;
`;

export const BotaoApagar = styled.button`
  margin-top: 10px;
  background: #fff;
  color: #c0392b;
  border: 1px solid #f0c8c2;
  border-radius: 10px;
  padding: 9px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background .15s;
  &:hover { background: #fdf3f2; }
  &:disabled { opacity: .5; cursor: default; }
`;

export const Explicacao = styled.p`
  margin: 6px 0 0;
  font-size: 12.5px;
  line-height: 1.5;
  color: #7b7b8a;
`;
